import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthUser, selectIsAuthenticated, selectOnboardingPending } from '../store/selectors.js';
import { resolveOnboardingPending } from '../lib/onboardingStatus.js';
import { getAuthReturnPath, getPostAuthDestination } from '../lib/authRedirect.js';

export function RequireGuest() {
  const isAuthed = useSelector(selectIsAuthenticated);
  const onboardingPending = useSelector(selectOnboardingPending);
  const user = useSelector(selectAuthUser);
  const effectiveOnboardingPending = resolveOnboardingPending({ onboardingPending, user });
  const location = useLocation();

  if (!isAuthed) return <Outlet />;

  const params = new URLSearchParams(location.search);
  const from = getAuthReturnPath(location, params);
  const target = getPostAuthDestination(
    from && from !== location.pathname ? from : '/courses',
    effectiveOnboardingPending,
  );

  return <Navigate to={target} replace />;
}
